import React, { useState, useEffect } from 'react';

interface ImageWithLoaderProps {
  src: string;
  alt: string;
  className?: string;
  style?: React.CSSProperties;
  onClick?: () => void;
  onError?: (e: React.SyntheticEvent<HTMLImageElement, Event>) => void;
  fallbackSrc?: string;
  activeCollection? : string | null
}

const ImageWithLoader: React.FC<ImageWithLoaderProps> = ({
  src,
  alt,
  className,
  style,
  onClick,
  onError,
  fallbackSrc = '/assets/images/dummy_product.png',
  activeCollection 
}) => {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const [imageSrc, setImageSrc] = useState(src);

  const handleLoad = () => {
    setLoading(false);
  };

  const handleError = (e: React.SyntheticEvent<HTMLImageElement, Event>) => {
    setLoading(false);
    setError(true);
    if (imageSrc !== fallbackSrc) {
      setImageSrc(fallbackSrc);
      setLoading(true); // Retry loading with fallback
    }
    if (onError) {
      onError(e);
    }
  };

  // Update imageSrc when src prop changes
  useEffect(() => {
    if (src !== imageSrc && !error) {
      setImageSrc(src);
      setLoading(true);
      setError(false);
    }
  }, [src]);

  const containerStyle: React.CSSProperties = {
    position: 'relative',
    display: 'inline-block',
    width: style?.width || '100%',
    height: style?.height || 'auto',
    ...(onClick ? { cursor: 'pointer' } : {})
  };

  return (
    <>
      <style>{`
        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
      `}</style>
      <div 
        style={containerStyle}
        className={className}
        onClick={onClick}
        onContextMenu={(e)=>{
          if(activeCollection == 'Canvas'){
  e.preventDefault()
          }
        
        }}
      >
        {loading && (
          <div
            style={{
              position: 'absolute',
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              backgroundColor: '#f5f5f5',
              zIndex: 1,
              minHeight: '100px',
            }}
          >
            <div
              style={{
                width: '40px',
                height: '40px',
                border: '3px solid #f3f3f3',
                borderTop: '3px solid #E7D5AD',
                borderRadius: '50%',
                animation: 'spin 1s linear infinite',
              }}
            />
          </div>
        )}
        <img
          src={imageSrc}
          alt={alt}
          onLoad={handleLoad}
          onError={handleError}
          style={{
            ...style,
            opacity: loading ? 0 : 1,
            transition: 'opacity 0.3s ease-in-out',
            display: 'block',
            width: '100%',
            height: '100%',
          }}
        />
      </div>
    </>
  );
};

export default ImageWithLoader;

